@if (splashState() !== 'off') {
  <div class="loader-wrapper" [class.fade-out]="splashState() === 'hidden'">
    <app-lottie-animation [src]="splashSrc()" />
  </div>
}
<div [dir]="orientation()" class="app-container">
  <p-toast />
  <mohlel-update-required-dialog />
  <router-outlet />
</div>
